
import React, { Component, useMemo,useEffect, useState } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { Container } from '@material-ui/core'
import * as PropTypes from 'prop-types'
import i18n from 'support/i18n'
import { Link, useHistory } from 'react-router-dom'
import * as pages from 'common_constants/Pages'
import NavigationService from 'support/navigation/NavigationService'
import styles from './View.Style'
import UserDetailSection from './components/user_detail_section/View'
import { UserIdeaList } from './components/UserIdeaList'
import IdeaListTable from './ListIdeaTable'
import ProfilePage from 'components_newui/profile/ProfilePage'
import { mapProfileResponse } from '../Innovate/unifiedBenchProfile/BenchprofileMapper'
import AddTeamMemberModal from '../Innovate/benchDetails/subcomponents/AddTeamMemberModal'

const Profile = (props) => {
  const history = useHistory();
  const {
    classes,
    InnovateUserIdeasList,
    InnovateUserIdeasListIsLoading,
    myEmail,
    match,
    getInnovateUserIdeas,
    isHackathonEnable,
    getBenchUserDisplayProfileFn,
    benchUserDisplayProfileResponse,
    myIdeasList,
    myIdeasLoading,
    addTeamMemberLoading,
    inviteTeamMemberLoading,
    getMyIdeasFn,
    addTeamMemberFn,
    inviteTeamMemberFn,
    onEditProfile

  } = props

  const [showAddTeamModal, setShowAddTeamModal] = useState(false)

  const { fullname, photo: getUserPhoto, alias: getUserEmail, availabilityInTeam } = benchUserDisplayProfileResponse

  const { params, path } = match;
  // 1. Check if the user is looking at their own profile
  const isMe = path.toLowerCase().endsWith('/me') || params.email === myEmail;
  // 2. Fallback to myEmail if it is me, otherwise use the route param email
  const userEmail = isMe ? myEmail : params.email;
  // 3. Enable editing only if the target email belongs to the logged-in user
  const isEnableEditProfileButton = userEmail === myEmail;


  const ROUTES = NavigationService.getRoutes()
  const benchProfileUserMePath = ROUTES[pages.BENCHPROFILE].path.replace(":email", myEmail);


  // 2. Create the function
  const handleUpdateProfileClick = () => {
    // Add your function logic here

    // This replaces the <Link> component
    history.push({
      pathname: benchProfileUserMePath
    });
  };

  useEffect(() => {
    if (userEmail) {
      getBenchUserDisplayProfileFn(userEmail)
      getInnovateUserIdeas(userEmail)
    }
  }, [userEmail])

  const ProfileResult = mapProfileResponse(benchUserDisplayProfileResponse);

  const filteredDataMyIdeasList = useMemo(() => {
  return [...myIdeasList.data || []].sort(
    (a, b) => (b?.created?.timestamp ?? 0) - (a?.created?.timestamp ?? 0)
  );
  }, [myIdeasList]);

  // console.log("filteredDataMyIdeasList==>", myIdeasList, filteredDataMyIdeasList)

  return (
    <div>


      <div className={classes.root}>

        {/* <div className={classes.alignHeading} style={{ margin: '0 2rem' }}>
          <Link to='/' className={classes.viewlink} > Back </Link>
        </div> */}

        <ProfilePage
          handleAddToTeam={() => setShowAddTeamModal(true)}
          onEditMyProfile={onEditProfile}
          isEnableEditProfileButton={isEnableEditProfileButton}
          onEditProfile={handleUpdateProfileClick}
          InnovateUserIdeasList={InnovateUserIdeasList}
          classes={classes}
          benchProfileResponse={ProfileResult}
        // userProfileData={profileData}
        />

        {/* Add Team Member Modal */}
        <AddTeamMemberModal
          isOpen={showAddTeamModal}
          onClose={() => setShowAddTeamModal(false)}
          userEmail={ProfileResult.email}
          userName={ProfileResult?.name}
          myIdeasList={filteredDataMyIdeasList}
          myIdeasLoading={myIdeasLoading}
          addTeamMemberLoading={addTeamMemberLoading}
          inviteTeamMemberLoading={inviteTeamMemberLoading}
          onAddTeamMember={addTeamMemberFn}
          onInviteTeamMember={inviteTeamMemberFn}
          getMyIdeasFn={getMyIdeasFn}
        />

      </div>
    </div>
  )
}

export default withStyles(styles)(Profile)
